module.exports = __webpack_public_path__ + "Panton-SemiBold.9bc61bf214a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-SemiBold.ttf
// module id = ./src/styles/fonts/Panton-SemiBold.ttf
// module chunks = 21